import { Component, inject } from '@angular/core';

import { AccessService } from 'src/app/services/access.service';

@Component({
  selector: 'app-group-link',
  templateUrl: './group-link.component.html',
  styleUrls: ['./group-link.component.scss']
})
export class GroupLinkComponent {
  private accessService = inject(AccessService);

  isGprmAud() {
    return this.accessService.isGprmAuditor() || this.accessService.isAdmin();
  }

  isGpiaAud() {
    return this.accessService.isGpiaAuditor() || this.accessService.isAdmin();
  }
}
